export function nextIndex(index, delta, length) { return length ? (index + delta + length) % length : 0; }
export function swipeDirection(start, end) { const diff = start - end; return Math.abs(diff) > 50 ? Math.sign(diff) : 0; }
